<template>
<div class="container mb-4 p-sm-3 col-md-8">
  <h1>撮影会／イベント／教室 開催後報告</h1>
  <p>
    <span class="attention">※</span>必須
  </p>
  <form class="mb-5" action="index.html" method="post">
    <div class="form-group p-3">
      <label for="lecturer-number">イベントタイトル</label>
      <p class="form-control-static">{{ item.event_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="lecturer-number">掲載終了日</label>
      <p class="form-control-static">{{ item.end_date }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventReport">
        参加人数（組数）報告（数字のみ）<span class="attention">※</span>
      </label>
      <input class="form-control" id="EventReport" style="ime-mode:disabled;" aria-required="true" v-model="event_report">
      <p class="error-msg" v-if="validation.event_report">{{ validation.event_report }}</p>
    </div>

    <div class="btn-group" role="group" aria-label="group">
      <a :href="reportConfirmPath" class="btn btn-primary btn-lg text-white" :class="confirmStyle" @click.prevent="onConfirm()">入力内容確認</a>
    </div>
  </form>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import api from 'api'
import modal from 'util/modal'
import lecturer from 'util/lecturer'
export default {
  data () {
    return {
      item: {},
      validation: {}
    }
  },
  created () {
    api.fetchEvent(this, this.$route.query.id)
    .then(item => {
      this.item = item
    }).catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  computed: {
    reportConfirmPath () {
      return '/report_confirm?id=' + this.$route.query.id
    },
    confirmStyle () {
      return this.item && this.item.event_id ? '' : 'disabled'
    },
    event_report: {
      set (value) { this.$store.commit('updateEventReport', value) },
      get () { return this.$store.state.eventReport.event_report }
    }
  },
  methods: {
    onConfirm () {
      this.validation = {}
      // 全角を半角に変換
      this.event_report = this.event_report.replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248)
      })
      // 必須チェック
      if (!this.event_report) {
        this.validation.event_report = '必ず入力してください'
        return
      }
      // 数字チェック
      if (!lecturer.isNumber(this.event_report)) {
        this.validation.event_report = '参加人数（組数）を数字で入力してください'
        return
      }
      this.$router.push(this.reportConfirmPath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportInput.vue?7f52feb8